import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	sprintStartedTitle: {
		id: 'backlog.flags.sprint-started-flag.sprint-started-title',
		defaultMessage: 'Sprint started',
		description: 'Title for flag starting a sprint',
	},
	sprintStartedDescription: {
		id: 'backlog.flags.sprint-started-flag.sprint-started-description',
		defaultMessage: 'We’ve taken you to your team’s sprint board. Good luck team!',
		description: 'Description for flag starting a sprint',
	},
	sprintStartedParallelSprintDescription: {
		id: 'backlog.flags.sprint-started-flag.sprint-started-parallel-sprint-description',
		defaultMessage: 'We’ve filtered the board to show your new sprint. Good luck, team!',
		description: 'Description for flag starting a sprint',
	},
});
